import _styled from '@emotion/styled/base';
import { forwardRef } from 'react';
import { Flex } from '../../Flex/index.js';
import { shorthandSpacingCss } from '../../primitives/Spacer/index.js';
import { StyledLabel, Label } from '../Label/index.js';
import { Message } from '../Message/index.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const StyledFieldset = _styled("fieldset", {
  target: "euub2gq1"
})("margin:0;padding:0;border:0;>", StyledLabel, "{margin-bottom:8px;}", shorthandSpacingCss, ";");
const StyledFlex = _styled(Flex, {
  target: "euub2gq0"
})(StyledLabel, "+", StyledLabel, "{", ({
  isInline
}) => !isInline && `margin-top: 8px;`, ";}");
const Fieldset = forwardRef(({
  ['data-testid']: dataTestId,
  children,
  disabled,
  error,
  inputSize,
  isInline,
  legend,
  message,
  name,
  ...props
}, ref) => jsxs(StyledFieldset, {
  "data-testid": dataTestId,
  ref: ref,
  ...props,
  children: [Boolean(legend) && jsx(Label, {
    isLegend: true,
    children: legend
  }), jsx(StyledFlex, {
    flexDirection: isInline ? 'row' : 'column',
    isInline: isInline,
    children: children
  }), (Boolean(error) || Boolean(message)) && jsx(Message, {
    error: error,
    message: message
  })]
}));

export { Fieldset };
